var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTopShop = function SvgTopShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 37,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003D54",
    d: "M16.49 23.2c3.428-6.376 7.386-9.384 13.711-9.384s8.169 5.48 4.407 9.385C28.977 29.045 18.53 30.497 16 30.497s-3.3-.246.49-7.296",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#topShop_svg__a)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00739E",
    d: "M15.914 23.2c2.672-6.376 5.757-9.384 10.686-9.384s6.368 5.48 3.435 9.385c-4.389 5.844-12.53 7.296-14.503 7.296-1.972 0-2.572-.246.382-7.296"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8EDF5",
    stroke: "#03143D",
    strokeWidth: 2,
    d: "M4.421 13.643c0-6.459 5.167-10.98 11.625-10.98s11.625 4.521 11.625 10.98c0 10.142-9.042 14.854-11.625 14.854S4.421 23.785 4.421 13.643Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#topShop_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#03143D",
    d: "m13.541 10.22-4.253.617-.075.015a.666.666 0 0 0-.294 1.123l3.082 3-.727 4.236-.009.073a.666.666 0 0 0 .976.63l3.804-2 3.796 2 .066.03a.668.668 0 0 0 .902-.733l-.728-4.237 3.083-3 .052-.057a.666.666 0 0 0-.422-1.08l-4.253-.617-1.902-3.853a.667.667 0 0 0-1.196 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "topShop_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.046 5.327h16v16h-16z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "topShop_svg__a",
    width: 29.671,
    height: 28.681,
    x: 7.875,
    y: 7.816,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_28556_26886",
    stdDeviation: 3
  })))));
};
export default SvgTopShop;